import { constants } from '../config';

/* **** showProductDetail *** */
export const showNotAllowedToBuy = (show) => ({
  type: constants.SHOW_NOT_ALLOWED_TO_BUY,
  show,
});
